import { FC, useMemo, useState } from "react";

import { BulkImportModal } from "./admin/BulkImportModal";
import { AdminCoursesView } from "./admin/content/AdminCoursesView";
import { ReportsView } from "./admin/reports/ReportsView";
import { AdminSettingsPanel } from "./admin/settings/AdminSettingsPanel";
import { AdminUsersList } from "./admin/users/AdminUsersList";

import { AdminOutcomesView } from "components/materials/home/admin/outcomes/AdminOutcomesView";
import { t } from "i18n/i18n";
import { IconText } from "mds/components/IconText";
import { TabBar } from "mds/components/TabBar";
import {
  DialSettingsIcon,
  OutcomeHashtagIcon,
  PersonClassIcon,
  TextBooksIcon,
  ThreeBarsIcon,
} from "mds/icons";
import { useTrackScreenViewEvent } from "utils/amplitude";

export const HomeAdminView: FC = () => {
  const [tabIndex, setTabIndex] = useState(0);
  // This needs to live here instead of the OrgUsersList component even though the
  // trigger for the modal is in the OrgUsersList component.  Reason being that
  // the bulk importer can create users which causes said org users list to re-render
  // and without re-create the modal.  To prevent that it lives here.
  const [showBulkImportModal, setShowBulkImportModal] = useState(false);

  useTrackScreenViewEvent("Home viewed");

  const tabs = useMemo(
    () => [
      {
        label: (
          <IconText
            iconStart={<TextBooksIcon className="group-data-[selected]/tab:text-blue" />}
            text={t("home.tabs.courses")}
            hideIconOnMd
          />
        ),
        title: t("home.tabs.courses"),
        eventName: "Home - View courses",
        panel: <AdminCoursesView />,
      },
      {
        label: (
          <IconText
            iconStart={<OutcomeHashtagIcon className="group-data-[selected]/tab:text-blue" />}
            text={t("glossary.outcome_index")}
            hideIconOnMd
          />
        ),
        title: t("glossary.outcomes"),
        eventName: "Home - View outcomes index",
        panel: <AdminOutcomesView />,
      },
      {
        label: (
          <IconText
            iconStart={<PersonClassIcon className="group-data-[selected]/tab:text-blue" />}
            text={t("home.tabs.users")}
            hideIconOnMd
          />
        ),
        title: t("home.tabs.users"),
        panel: <AdminUsersList onShowBulkImportModal={() => setShowBulkImportModal(true)} />,
        eventName: "Home - View users",
      },
      {
        label: (
          <IconText
            iconStart={<ThreeBarsIcon className="group-data-[selected]/tab:text-blue" />}
            text={t("home.tabs.reports")}
            hideIconOnMd
          />
        ),
        title: t("home.tabs.reports"),
        panel: <ReportsView />,
        eventName: "Home - View reports",
      },
      {
        label: (
          <IconText
            iconStart={<DialSettingsIcon className="group-data-[selected]/tab:text-blue" />}
            text={t("home.tabs.settings")}
            hideIconOnMd
          />
        ),
        title: t("home.tabs.settings"),
        panel: <AdminSettingsPanel />,
        eventName: "Home - View settings",
      },
    ],
    [],
  );

  return (
    <div className="h-full w-full overflow-hidden">
      <TabBar
        className="h-full"
        selectedIndex={tabIndex}
        tabListClassName="ml-2 gap-x-6"
        tabs={tabs}
        onChange={setTabIndex}
      />

      {showBulkImportModal && <BulkImportModal onClose={() => setShowBulkImportModal(false)} />}
    </div>
  );
};
